export default "__VITE_ASSET__58cb49dd__"